/*
 * /TestingBanner Messages
 *
 * This contains all the text for the TestingBanner component.
 */

import { defineMessages } from 'react-intl'

export const scope = 'app.components.TestingBanner'

export default defineMessages({
		header: {
			id: `${scope}.header`,
			defaultMessage: 'Thank you for beta testing this ticketing portal. Tickets issued here are not valid for entry unless explicitly stated.',
		},
})
